exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customers[data-v-39fe105d]{font-family:Trebuchet MS,Arial,Helvetica,sans-serif;border-collapse:collapse;width:100%}#customers td[data-v-39fe105d],#customers th[data-v-39fe105d]{border:2px solid #ddd;padding:8px;text-align:left;width:1%;white-space:nowrap}#customers tr[data-v-39fe105d]:nth-child(2n){background-color:#f2f2f2}#customers tr[data-v-39fe105d]:hover{background-color:#ddd}#customers th[data-v-39fe105d]{padding-top:12px;padding-bottom:12px;text-align:left;background-color:#595a59;color:#fff}#auto[data-v-39fe105d]{overflow-x:auto;width:100%}.anim[data-v-39fe105d]{width:150px}.numFont[data-v-39fe105d]{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39fe105d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procurement/voucher/admin_voucher_form.vue
// module id = 1438
// module chunks = 3